import alt from 'components/Dispatcher';
import immutable from 'immutable';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import {oauthRedirect} from 'utils/oauthRedirect';
import OAuthActions from 'actions/OAuthActions';
import OAuthSource from 'sources/OAuthSource';

@immutableStore
class OAuthStore {
  constructor() {
    this.state = immutable.Map({
      oauthStatus: immutable.List(),
    });
    this.bindActions(OAuthActions);
    this.registerAsync(OAuthSource);
  }

  onFetchStatus() {
    setTimeout(() => {
      this.getInstance().fetchStatus();
    }, 0);
  }

  /**
   * Update this.state.get('oauthStatus') using a server-side response object
   * @param  {object} data A {args, response} object
   */
  updateOAuthStatus(data) {
    let status = immutable.List();
    for (let state of data.data.oauth_status) {
      let oauth_state = state;
      oauth_state.key = oauth_state.name;
      status = status.push(oauth_state);
    }
    const state = this.state.set('oauthStatus', status);
    this.setState(state);
  }

  /**
   * Update this.state.get('oauthStatus') using a server-side response
   * @param  {object} data A {args, response} object
   */
  onFetchStatusSuccess(data) {
    this.updateOAuthStatus(data);
  }

  onRedirectUrl(apiName) {
    setImmediate(() => {
      this.getInstance().redirectUrl(apiName);
    });
  }
  onRedirectUrlSuccess(resp) {
    if (resp.data.url) {
      oauthRedirect(resp.data.url);
    }
  }
  onRedirectUrlFailed(resp) {
    if (resp.url) {
      oauthRedirect(resp.url);
    }
  }
}

export default alt.createStore(OAuthStore, 'OAuthStore');
